/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStockonhandReportCtrl
 */
angular.module('mercury.modules.stock.stockonhandreport')
.controller('StockStockonhandReportCtrl', ["dialog", "$filter", "$scope", "$state", "$stateParams", "StockOnHand", "title", function(dialog, $filter, $scope, $state, $stateParams, StockOnHand, title) {
  title.set('Stock On Hand Report');

  $scope.reportTotal = 0;
  $scope.reportData = StockOnHand.StockOnHandReport($stateParams.templateType, $stateParams.templateId);
  $scope.reportData.then(function(report) {
    $scope.reportData.title = report.title + ' - ' + moment(report.generatedTime).format('ddd, Do, MMM hh:mm:ssa');
    $scope.reportData.groups = [];
    $scope.reportData.totalValue = 0;
    angular.forEach(report.lines, function(line) {
      if (line.groupHeader) {
        $scope.reportData.groups.push({
          header: line.groupHeader,
          lines: [],
          totalValue: 0
        });
      } else {
        $scope.reportData.groups[$scope.reportData.groups.length - 1].lines.push(line);
        $scope.reportData.groups[$scope.reportData.groups.length - 1].totalValue += line.qtyOnHand * line.unitCost;
        $scope.reportTotal += line.qtyOnHand * line.unitCost;
      }
    });
  });

  $scope.showReceived = function(reportLine) {
    $state.go('.Received',
      {itemId: reportLine.stockItemId, startTime: reportLine.openingQtyDate, endTime: reportLine.closingDate},
      {location: 'replace'});
  };

  $scope.showCalculatedUsage = function(reportLine) {
    $state.go('.CalculatedUsage',
      {
        itemId: reportLine.stockItemId,
        startTime: reportLine.openingQtyDate,
        endTime: reportLine.closingDate,
        unitName: reportLine.unit.name,
        unitRatio: reportLine.unit.ratio
      },
      {location: 'replace'});
  };

  $scope.showPriceBox = function(reportLine, quantity) {
    $state.go('.StockPrice',
      {itemId: reportLine.stockItemId, quantity: quantity, unitName: reportLine.unit.name, unitRatio: reportLine.unit.ratio},
      {location: 'replace'});
  };

  $scope.showStocktakeBox = function(reportLine) {
    dialog.open({
      templateUrl: 'modules/stock/stockonhandreport/stocktakebox.tpl.html',
      controller: 'StockStockonhandStocktakeboxCtrl',
      size: 'lg',
      resolve: {
        reportLine: function() {
          return reportLine;
        }
      }
    });
  };
}]);
